import { useState, useEffect } from 'react';
import { debounce } from 'lodash';

// Breakpoint constants matching design system
export const PHONE_BREAKPOINT = 600;
export const TABLET_BREAKPOINT = 975;

interface ScreenSize {
  width: number;
  height: number;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

const getInitialSize = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return {
    width,
    height,
    isMobile: width <= PHONE_BREAKPOINT,
    isTablet: width > PHONE_BREAKPOINT && width <= TABLET_BREAKPOINT,
    isDesktop: width > TABLET_BREAKPOINT,
  };
};

const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>(getInitialSize);

  useEffect(() => {
    const handleResize = debounce(() => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setScreenSize({
        width,
        height,
        isMobile: width <= PHONE_BREAKPOINT,
        isTablet: width > PHONE_BREAKPOINT && width <= TABLET_BREAKPOINT,
        isDesktop: width > TABLET_BREAKPOINT,
      });
    }, 100);

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      handleResize.cancel(); // Cancel any pending debounced calls
    };
  }, []);

  return screenSize;
};

export default useScreenSize;
